const APPURL = require('../Constants/URLConstants');

export const HR = {
  departments: APPURL.URLPaths.hrDepartments,
  jobProfiles: APPURL.URLPaths.hrJobProfiles,
  payGrades: APPURL.URLPaths.hrPayGrades,
  staff: APPURL.URLPaths.hrStaff,
  shifts: APPURL.URLPaths.hrShifts,
  attendance: APPURL.URLPaths.hrAttendance,
  leavePolicies: APPURL.URLPaths.hrLeavePolicies,
  leaveBalances: APPURL.URLPaths.hrLeaveBalances,
  leaveRequests: APPURL.URLPaths.hrLeaveRequests,
  payrollRuns: APPURL.URLPaths.hrPayrollRuns,
  payslips: runId => `${APPURL.URLPaths.hrPayrollRuns}/${runId}/payslips`,
  payslip: (runId, payslipId) => `${APPURL.URLPaths.hrPayrollRuns}/${runId}/payslips/${payslipId}`,
  payComponents: APPURL.URLPaths.hrPayComponents,
  expenseCategories: APPURL.URLPaths.hrExpenseCategories,
  expenseClaims: APPURL.URLPaths.hrExpenseClaims,
};
